/** English of the interface (ADR 0069), keyed by the exact French phrase. See `index.ts`. */
export const FRONT: Readonly<Record<string, string>> = {
  // ui/welcome.ts
  Shefira: 'Shefira',
  Bêta: 'Beta',
  'Un MMORPG en pixel art inspiré de BrowserQuest : gratuit, sans inscription, en jeu en cinq secondes.':
    'A pixel art MMORPG inspired by BrowserQuest: free, no sign-up, playing in five seconds.',
  'Un MMORPG en pixel art inspiré de BrowserQuest, dans ton navigateur : gratuit, sans inscription, en jeu en cinq secondes.':
    'A pixel art MMORPG inspired by BrowserQuest, right in your browser: free, no sign-up, playing in five seconds.',
  'Le jeu': 'The game',
  'Un monde ouvert': 'An open world',
  'Boss et donjons': 'Bosses and dungeons',
  'Groupes et guildes': 'Parties and guilds',
  'Choisis ton pseudo': 'Pick your nickname',
  Pseudo: 'Nickname',
  'Entrer dans le monde': 'Enter the world',
  'Sans inscription : tu pourras créer un compte plus tard, depuis le jeu.':
    'No sign-up: you can create an account later, from inside the game.',
  'J’ai déjà un compte': 'I already have an account',
  'Retrouve tes personnages': 'Find your characters',
  'E-mail': 'Email',
  'Mot de passe': 'Password',
  'Se connecter': 'Sign in',
  'Mot de passe oublié ?': 'Forgot your password?',
  'Jouer sans compte': 'Play without an account',
  'Mot de passe oublié': 'Forgotten password',
  'Donne l’adresse de ton compte : tu y recevras un lien pour choisir un nouveau mot de passe.':
    'Enter your account’s email address: you’ll get a link there to choose a new password.',
  'Recevoir le lien': 'Send me the link',
  'Retour à la connexion': 'Back to sign-in',
  'Nouveau mot de passe': 'New password',
  'Encore une fois': 'Once more',
  'Confirme le mot de passe': 'Confirm the password',
  'Changer et se connecter': 'Change and sign in',
  'Demander un nouveau lien': 'Ask for a new link',
  ou: 'or',
  'Rejoins la communauté sur Discord': 'Join the community on Discord',
  'Annonces, groupes, bugs et suggestions': 'News, parties, bugs and ideas',
  Instagram: 'Instagram',
  'Suis-nous sur Instagram': 'Follow us on Instagram',
  CGU: 'Terms of Use',
  CGV: 'Terms of Sale',
  'Données personnelles': 'Privacy',
  'Mentions légales': 'Legal notice',
  'Signaler un problème': 'Report a problem',
  'Continuer avec {provider}': 'Continue with {provider}',
  'Connexion impossible': 'Could not sign in',
  'Ton personnage': 'Your character',
  'Donne ton adresse e-mail': 'Enter your email address',
  'Si un compte utilise {address}, un lien vient d’y partir. Pense à regarder dans les indésirables.':
    'If an account uses {address}, a link is on its way there. Remember to check your spam folder.',
  'Ce lien n’est plus valable : demande-en un nouveau.':
    'This link has expired: ask for a new one.',
  'Le mot de passe fait au moins {count} caractères':
    'The password must be at least {count} characters',
  'Les deux mots de passe ne sont pas les mêmes': 'The two passwords don’t match',

  // ui/customise.ts
  Face: 'Front',
  'Profil droit': 'Right side',
  Dos: 'Back',
  'Profil gauche': 'Left side',
  'Personnaliser ton personnage': 'Customize your character',
  "Choisis son apparence avant d'entrer dans Shefira.":
    'Choose their look before entering Shefira.',
  'Aperçu du personnage': 'Character preview',
  'Faire tourner le personnage': 'Turn the character',
  'Tourner vers la gauche': 'Turn left',
  'Tourner vers la droite': 'Turn right',
  "Avec l'équipement de départ": 'With the starting Equipment',
  Classe: 'Class',
  Coiffure: 'Hairstyle',
  Corps: 'Body',
  'Couleur de peau': 'Skin color',
  'Couleur des cheveux': 'Hair color',
  'Couleur des yeux': 'Eye color',
  'Surprends-moi': 'Surprise me',
  Retour: 'Back',
  'Créer ce personnage': 'Create this character',
  Masquée: 'Hidden',

  // ui/roster.ts
  'En jeu': 'Playing',
  Supprimer: 'Delete',
  'Supprimer {name}': 'Delete {name}',
  'Nouveau personnage': 'New character',
  'Serveur injoignable': 'Server unreachable',
  'Tes personnages': 'Your characters',
  'Nom du nouveau personnage': 'New character’s name',
  Créer: 'Create',
  'Se déconnecter': 'Sign out',
  'Supprimer mon compte': 'Delete my account',
  'Compte invité : enregistre-le depuis le jeu pour le retrouver ailleurs.':
    'Guest account: save it from inside the game to find it anywhere.',
  Compte: 'Account',
  'Action impossible': 'Could not do that',

  // ui/account-tab.ts
  'Clique un autre personnage pour l’incarner.': 'Click another character to play them.',
  'Ajoute un e-mail et un mot de passe pour retrouver tes personnages depuis n’importe quel navigateur. Rien n’est perdu : c’est le même compte.':
    'Add an email and a password to find your characters from any browser. Nothing is lost: it’s the same account.',
  'Enregistrer le compte': 'Save the account',
  'Ou retrouve ton compte avec :': 'Or sign in to your account with:',
  'Retour à l’accueil': 'Back to Home',
  'Compte invité': 'Guest account',
  'Compte {services}': '{services} account',
  'Lier {provider}': 'Link {provider}',

  // ui/changelog-modal.ts
  'Version {version}': 'Version {version}',
  Nouveautés: 'What’s new',
  Nouveau: 'New',
  Amélioré: 'Improved',
  Corrigé: 'Fixed',
  'Fermer (Échap)': 'Close (Esc)',

  // ui/delete-character-modal.ts
  'Supprimer {name} ?': 'Delete {name}?',
  'Son équipement, son or, ses quêtes et ses succès disparaissent pour toujours. Tape son nom pour confirmer.':
    'Their Equipment, gold, Quests and Achievements will be gone forever. Type their name to confirm.',
  'Nom du personnage': 'Character name',
  Annuler: 'Cancel',
  'Suppression impossible': 'Could not delete',
  'Annuler (Échap)': 'Cancel (Esc)',
  'Supprimer ton compte ?': 'Delete your account?',
  'Tous tes personnages, leur équipement, leur or et tes achats disparaissent pour toujours, sans remboursement. Tape {word} pour confirmer.':
    'All your characters, their Equipment, their gold and your purchases will be gone forever, with no refund. Type {word} to confirm.',
  SUPPRIMER: 'DELETE',
  'Mot de confirmation': 'Confirmation word',

  // ui/guest-reminder.ts
  'Enregistrer mon compte': 'Save my account',
  'Ton compte n’est pas enregistré': 'Your account isn’t saved',
  'Si tu te déconnectes maintenant, tes personnages disparaissent avec ce compte invité : rien ne permettra de les retrouver. Enregistre ton compte avec un e-mail, Google ou Steam pour les garder.':
    'If you sign out now, your characters vanish with this Guest account: there will be no way to get them back. Save your account with an email, Google or Steam to keep them.',
  'Si tu te déconnectes maintenant, tes personnages disparaissent avec ce compte invité : rien ne permettra de les retrouver. Entre en jeu et enregistre ton compte (Profil, onglet Compte) pour les garder.':
    'If you sign out now, your characters vanish with this Guest account: there will be no way to get them back. Enter the game and save your account (Profile, Account tab) to keep them.',
  'Me déconnecter quand même': 'Sign out anyway',
  Rester: 'Stay',
  'Garde ton héros': 'Keep your hero',
  'La prairie est derrière toi, et ton personnage vit sur un compte invité : s’il se déconnecte ou change de navigateur, il est perdu. Enregistre ton compte avec un e-mail, Google ou Steam pour le retrouver partout.':
    'The meadow is behind you, and your character lives on a Guest account: sign out or switch browsers and they’re lost. Save your account with an email, Google or Steam to find them anywhere.',
  'Plus tard': 'Later',

  // ui/profile-format.ts
  'moins d’une minute': 'less than a minute',
  '{minutes} min': '{minutes} min',
  '{hours} h': '{hours} h',
  '{hours} h {minutes} min': '{hours}h {minutes}m',
  '{day} {month} {year}': '{month} {day}, {year}',
  janvier: 'January',
  février: 'February',
  mars: 'March',
  avril: 'April',
  mai: 'May',
  juin: 'June',
  juillet: 'July',
  août: 'August',
  septembre: 'September',
  octobre: 'October',
  novembre: 'November',
  décembre: 'December',

  // ui/profile-panel.ts
  Profil: 'Profile',
  Succès: 'Achievements',
  Or: 'Gold',
  'Portails découverts': 'Portals found',
  'Aventurier depuis le {date}': 'Adventurer since {date}',
  Vie: 'Health',
  DPS: 'DPS',
  Défense: 'Defense',
  Carrière: 'Career',
  'Ennemis vaincus': 'Enemies defeated',
  'Boss vaincus': 'Bosses defeated',
  Chutes: 'Deaths',
  'Plus gros coup': 'Biggest hit',
  'Dégâts infligés': 'Damage dealt',
  'Sorts lancés': 'Spells cast',
  'Objets ramassés': 'Items picked up',
  'Cases parcourues': 'Tiles walked',
  'Temps de jeu': 'Time played',

  // ui/profile-sections.ts
  'Niveau maximum': 'Max Level',
  'Tableau de chasse': 'Hunting record',
  'Aucun ennemi vaincu pour l’instant.': 'No enemies defeated yet.',

  // ui/minimap.ts
  'Agrandir la mini-carte': 'Enlarge the minimap',
  'Réduire la mini-carte': 'Shrink the minimap',
  // ui/settings-panel.ts
  Son: 'Sound',
  Touches: 'Controls',
  Affichage: 'Display',
  'Chiffres de dégâts': 'Damage numbers',
  'Cadre rouge en combat': 'Red frame in combat',
  'Alerte de vie basse': 'Low health warning',
  'Mini-carte': 'Minimap',
  'Afficher le chat': 'Show chat',
  "Secousses et éclairs de l'écran": 'Screen shake and flashes',
  'Nuit et météo': 'Night and weather',
  'Vibration aux coups reçus': 'Vibrate when hit',
  'Afficher le ping': 'Show ping',
  Oui: 'Yes',
  Non: 'No',
  'Touche réservée': 'Reserved key',
  'Échangée avec {action}': 'Swapped with {action}',
  Réglages: 'Settings',
  Effets: 'Effects',
  Musique: 'Music',
  '{value} %': '{value}%',
  'Clique une touche puis appuie sur la nouvelle. Échap annule ; Entrée et Échap sont réservées.':
    'Click a key, then press the new one. Esc cancels; Enter and Esc are reserved.',
  'Touches par défaut': 'Default controls',
  Langue: 'Language',
  Entrer: 'Enter',
  'fullscreen|Quitter': 'Exit',
  Quitter: 'Leave',
  'Plein écran': 'Fullscreen',
  "Retour à l'accueil": 'Back to Home',
  'Appuie…': 'Press…',
};
